import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function WorkerLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Topbar */}
      <header className="fixed top-0 inset-x-0 h-16 bg-blue-950 text-white z-40">
        <div className="max-w-screen-xl mx-auto h-full px-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/fotos/Logo_blanco_EKINE.png" alt="EKINE" className="h-8 w-auto" />
            <span className="opacity-80 text-sm">Panel del trabajador</span>
          </div>
          <div className="text-sm">
            <span className="mr-3 opacity-90">{user?.email}</span>
            <button
              onClick={logout}
              className="px-3 py-1 rounded-md bg-white/10 border border-white/20 hover:bg-white/20"
            >
              Cerrar sesión
            </button>
          </div>
        </div>
      </header>

      {/* Sidebar + content */}
      <div className="max-w-screen-xl mx-auto px-4 pt-20 pb-10 grid md:grid-cols-[200px,1fr] gap-6">
        <aside className="hidden md:block">
          <nav className="bg-white rounded-xl border shadow-sm p-2 sticky top-20">
            <MenuItem to="/trabajador/agenda" label="Agenda" />
            <MenuItem to="/trabajador/pacientes" label="Pacientes" />
            <MenuItem to="/trabajador/seguimiento" label="Seguimiento" />
            <MenuItem to="/trabajador/desempeno" label="Mi desempeño" />
          </nav>
        </aside>

        <main className="min-h-[60vh]">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function MenuItem({ to, label }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `block px-3 py-2 rounded-lg text-sm ${
          isActive ? 'bg-blue-50 text-blue-800 font-semibold' : 'hover:bg-slate-50'
        }`
      }
    >
      {label}
    </NavLink>
  );
}
